// src/config/allowedBillingConcepts.js

/**
 * Default list with specific billing concept codes shown initially
 * in the Concepts Autocomplete component, filtering out the rest
 * unless the user specifies otherwise.
 */
export const ALLOWED_BILLING_CONCEPTS = [
  'FLETECO2PI',
  'FLETECO2FL',
  'FLETELINPL',
  'FLETELINPI',
  'FLETELINFL',
  'FLDCRCO2FL',
  'FLDTRLINPI',
  'FLDTRLINFL',
  'AUTOPCO2PL',
  'AUTOPCO2PI',
  'AUTOPLINPI',
  'AUTOPLINFL',
  'BASCUCO2PI',
  'BASCUCO2FL',
  'MANIOXXXXX',
  'ESTANXXXXX',
  'DOBOPCO2PI',
  'DOBOPLINPI',
  'DOBOPLINFL'
];

/**
 * Devuelve los códigos de la lista curada que ya no existen en el catálogo.
 *
 * Esta lista no se puede derivar: qué conceptos salen por defecto es decisión
 * de Lyta, no dato de Cryoinfra. Lo que sí se puede es avisar cuando un código
 * desaparece, para que la lista no se pudra en silencio.
 *
 * Un catálogo vacío significa "todavía no cargó", no "ninguno existe".
 *
 * @param {Array<String>} permitidos
 * @param {Array<Object>} catalogo Respuesta de ConceptoGasto/Consultar.
 * @returns {Array<String>}
 */
export const codigosPermitidosInexistentes = (permitidos, catalogo) => {
  if (!Array.isArray(catalogo) || catalogo.length === 0) return [];
  const existentes = new Set(catalogo.map((concepto) => concepto?.CodigoGasto));
  return (permitidos || []).filter((codigo) => !existentes.has(codigo));
};
